import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postAccounting({ body }) {
  return BaseService.post(REST.ACCOUNTING, body);
}

function putAccounting({ body, id }) {
  return BaseService.put(REST.ACCOUNTING_ID(id), body);
}

function getAccounting(params) {
  return BaseService.get(REST.ACCOUNTING, {
    params: paramsFilter({ params }),
  });
}

function deleteAccounting({ id }) {
  return BaseService.delete(REST.ACCOUNTING_ID(id));
}

export default {
  deleteAccounting,
  getAccounting,
  putAccounting,
  postAccounting,
};
